import React from 'react';
import PT from 'prop-types';
import { 
    toLower, join, map, 
    size, find, debounce,
    identity, concat, assign, filter,
    flatMap, isEmpty, includes, union
} from 'lodash';
import tsRest from 'ts-rest-client';
import { CardsSection } from './cardssection';
import TranslatorManager from 'ts-translate-js';
import moment from 'moment';
import { WaitSpinners } from 'ts-common-react-controls';
import { Button, Dropdown, DatePicker, Textbox, Chip } from '../toolkit';
import { NoProductSection } from './othercontrols';
import { convertTicksToDate } from '../util';

const tr = TranslatorManager.boundTR;
const SEARCH_PRODUCTS_DELAY_MS = 1000;

/*
type RepresentationType = {
    id: string,
    type: string,
};
*/

export class SearchWidget extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: [],
            regions: {},
            selectedRegion: "",
            searchKit: {},
            loadingSearchResults: props.loadingSearchResults,
            loadingRegionResult: false,
            loadingUrls: true,
            loadingProposalKit: false,
            searchSpinner: false,
            startDate: null,
            endDate: null,
            focusedInput: null,
            drop: 0,
            take: (this.props.pagging != undefined) ? this.props.pagging : 12,
            showAdvancedSearch: false,
            selectedDate: new Date(),
            urls: {},
            representationTypes: [],
            searchForPOS: false,
            searchFailed: false,
            proposalKit: this.props.proposalKit,
            initialShopAllProductsLoading: false,
        };

        this.searchProductDebounced = debounce(this.searchProducts.bind(this), SEARCH_PRODUCTS_DELAY_MS);
    }

    componentDidMount() {
        this.fetchUrlsAndFiltersContent();
        if (tsapp.isShop && !tsapp.isLiteShop) {
            this.setState({ initialShopAllProductsLoading: true });
            this.searchProducts();
        }
    }

    //#region Requests
    async loadUrls() {
        const urls = await tsRest.get("/integration/" + this.props.integ + "/urls");
        return urls;
    }
    
    async loadRegionsForSelect() {
        const regions = await tsRest.get(`/integration/${this.props.integ}/physicalvenues/all/regions/all/${this.props.lang}`);
        return regions;
    }
    
    async loadRepresentationTypes() {
        const representationTypes = await tsRest.get(`/representationtypes/all/${this.props.lang}`);
        return representationTypes;
    }
    
    async loadPhysicalVenues() {
        const physicalVenues =  await tsRest.get(`/integration/rese/physicalvenues/all/${this.props.lang}`);
        return physicalVenues;
    }

    async searchProducts(filters) {
        this.cancelCurrentSearchIfNeeded();

        if (filters == undefined)
            filters = this.state.filters;

        this.setState({loadingSearchResults: true, searchFailed: false});
        let baseUrl = `/integration/rese/${this.props.sellerId}/products/search/${this.props.lang}`;

        if (this.searchCall == null) {
            this.searchCall = tsRest.get(baseUrl + this.buildParameters(filters));
        }
        
        try {
            // Get search kit (products, filters)
            const searchKit = await this.searchCall;
            
            // Update everything!
            this.setState({
                loadingSearchResults: false, 
                // In shop mode, we only need products, since filters are already built by the API
                searchKit: tsapp.isShop ? {products: searchKit.products} : searchKit,
            });

            this.searchCall = null;
        }
        catch(err) {
            // We don't want to display an error if the request was aborded.
            if (!err.isAborted)
                this.setState({ loadingSearchResults: false, searchFailed: true });
        }
    }

    async fetchUrlsAndFiltersContent() {
        const filters = this.checkForFilters();

        //Promise.all
        const urls = await this.loadUrls();
        const regions = await this.loadRegionsForSelect();
        const representationTypes = await this.loadRepresentationTypes();
        
        
        const physicalVenues = await this.loadPhysicalVenues();

        this.setState({
            loadingUrls: false,
            urls: urls,
            regions: regions,
            representationTypes: representationTypes,
            physicalVenues: physicalVenues,
            filters: filters
        });

        this.afterFiltersUpdate(filters);
    }

    async loadProposalKit() {
        this.setState({ loadingProposalKit: true });
        const proposalKit = await tsRest.get(this.props.proposalKitLoadUrl);
        this.setState({ proposalKit: proposalKit, loadingProposalKit: false });
    }
    //#endregion

    //#region Events handling
    triggerSearchProduct() {
        this.searchProducts();
    }

    handleUpdateFilter(name, value) {
        // If value is empty, remove filter
        if (value == "" || value == undefined) {
            this.handleRemoveFilter(name);
            return;
        }

        let filter = this.getFilterFromName(name);
        let allFilters;

        if (filter != undefined) {
            allFilters = map(this.state.filters, filter => {
                if (filter.name === name) filter = assign({}, filter, { value });
                return filter;
            });
        } else {
            allFilters = concat(this.state.filters, { name: name, value: value });
        }

        this.setState({ filters: allFilters });
        this.afterFiltersUpdate(allFilters);
    }

    handleRemoveFilter(filterToRemove) {
        let allFilters = filter(this.state.filters, f => { return f.name != filterToRemove; });
        this.setState({ filters: allFilters });

        this.afterFiltersUpdate(allFilters);
    }

    afterFiltersUpdate(allFilters) {
        // Update URL to show active filters
        this.updateUrlWithParameters(this.buildParameters(allFilters));

        if (size(allFilters) > 0) {
            // Put control in seach mode
            this.setState({ loadingSearchResults: true, initialShopAllProductsLoading: false });

            // Start search!
            this.searchProductDebounced(allFilters);
        } else if (this.state.proposalKit == undefined) { // Load proposal kit if needed
            this.loadProposalKit();
        }
    }

    handleOnDateCriteriaChange([fromDate, toDate]) {
        let allFilters;
        if (fromDate != undefined && fromDate != toDate) {
            allFilters = concat(this.state.filters, { name: "fromDate", value: fromDate });
        }
        if (toDate != undefined) {
            allFilters = concat(allFilters != undefined? allFilters : this.state.filters, { name: "toDate", value: toDate });
        }

        this.setState({ filters: allFilters });
        this.afterFiltersUpdate(allFilters);
    }
    //#endregion

    //#region Utils
    updateUrlWithParameters(parameters) {
        if (parameters.length > 0) {
            window.history.replaceState('filters', 'Reservatech.net | Résultats', parameters);
        } else {
            window.history.replaceState({}, 'Reservatech.net', location.pathname);
        }
    }

    cancelCurrentSearchIfNeeded() {
        if (this.searchCall != null) {
            this.searchCall.abort();
            this.searchCall = null;
        }
    }

    buildParameters(filters) {
        let urlParameters = join(map(filters, filter => {
            return `${toLower(filter.name)}=${filter.value}`;
        }), "&");

        return (size(urlParameters) > 0) ? `?${urlParameters}` : "";
    }

    generateFilterChips() {
        if (!isEmpty(this.state.searchKit)) 
            return [...this.createNonRemovableChips(), ...this.createRemovableChips()];
        return null;
    }

    createNonRemovableChips() {
        return map(this.state.searchKit.filters, (filter, index) => {
            const key = filter.type + index;
            return <Chip key={key} chipText={filter.content} canBeRemoved={false} />;
        });
    }
    
    createRemovableChips() {
        let _this = this;
        return map(this.state.filters, filter => {
            const { name, value } = filter;
            const canCreateChip = value != undefined && !includes(map(_this.state.searchKit.filters, filter => identity(filter).type), name);
            if (canCreateChip) {
                let chipText = value;
                if (name == "fromDate") {
                    chipText = tr("Du {fromDate}", { fromDate: moment(value).format('LL') });
                } else if (name == "toDate") {
                    chipText = tr("Jusqu'au {toDate}", { toDate: moment(value).format('LL') });
                } else if (name == "representationType") {
                    chipText = _this.getRepresentationTypeNameById(value);
                } else if (name == "physicalVenue") {
                    chipText = _this.getPhysicalVenueNameById(value);
                }

                return <Chip key={name} chipText={chipText} closeIcon={{className:"fas fa-times"}} onClick={_this.handleRemoveFilter.bind(_this, name)} />;
            }
        });
    }

    getRepresentationTypeNameById(id) {
        if (this.state.representationTypes == undefined)
            return;

        // 1- Retrieve only parent types
        let onlyParentTypes = map(this.state.representationTypes, type => { return { name: type.name, id: type.id }; });

        // 2- Retrieve and flatten each type's children
        let onlyChildrenTypes = flatMap(map(this.state.representationTypes, "children"));

        // 3- Merge everything!
        const allTypes = union(onlyParentTypes, onlyChildrenTypes);

        // 4- Find the selected representation type
        let representationType = find(allTypes, function(type) { return type.id == id; });
        return (representationType != undefined) ? representationType.name : null;
    }

    getPhysicalVenueNameById(id) {
        if (this.state.physicalVenues == undefined)
            return;

        let onlyPhysicalVenues = flatMap(map(this.state.physicalVenues, "physicalVenues"));
        let physicalVenue = find(onlyPhysicalVenues, function(phyVenue) { return phyVenue.id == id; });
        return (physicalVenue != undefined) ? physicalVenue.name : null;
    }

    checkForFilters() {
        const parsedUrl = new URL(window.location.href);

        if (parsedUrl.search != undefined) {
            return this.createFiltersFromUrlParams(parsedUrl);
        }
        return {};
    }

    getFilterValue(filterName) {
        const filter = find(this.state.filters, {'name': filterName});
        return filter != undefined ? filter.value : undefined;
    }

    getFilterValueFromUrl(filterName) { 
        const parsedUrl = new URL(window.location.href);
        const result = this.extractUrlParam(parsedUrl.searchParams, filterName);
        return result;
    }

    getFilterFromName(name) {
        return find(this.state.filters, {'name': name});
    }

    getDateFilters() {
        const dateFormat = "YYYY-MM-DD";
        const dateFormatRegex = new RegExp(/^\d{4}-\d{2}-\d{2}$/);

        let fromDate = this.getFilterValue("fromDate");
        let toDate = this.getFilterValue("toDate");

        if (fromDate == undefined && toDate == undefined)
            return null;
        
        // If fromDate is still null, init it to today (search needs two dates)
        if (fromDate == undefined)
            fromDate = moment();
        else if (!dateFormatRegex.exec(fromDate)) // If .NET integer format (ticks)
            fromDate = convertTicksToDate(fromDate, moment);
        else
            fromDate = moment(fromDate);
        
        let fromYear = fromDate.year(); // We need to keep tracking of the year, in order to init an undefined toDate
        fromDate = fromDate.format(dateFormat);
        
        // If toDate is still null, init it to 2 years after fromDate (search needs two dates)
        if (toDate == undefined)
            toDate = moment().year(fromYear).add(2, 'year').format(dateFormat);
        else if (!dateFormatRegex.exec(toDate)) // If .NET integer format (ticks)
            toDate = convertTicksToDate(toDate, moment).format(dateFormat);
        else
            toDate = moment(toDate).format(dateFormat);
        
        return [ moment(fromDate).toDate(), moment(toDate).toDate() ];
    }

    //#region Search params extraction
    extractUrlParam(params, paramName) {
        // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(paramName, 'gi'); // Search paramName with case-insensitive
        return params.get(regex.exec(params));
    }

    extractSearchFocusParam(params) { 
        return this.extractUrlParam(params, "searchfocus") || false;
    }

    extractSearchTextParam(params) {
        return this.extractUrlParam(params, "searchtext") 
        || this.extractUrlParam(params, "EventText")  // StandardSearch.aspx
        || this.extractUrlParam(params, "EventNameText"); // StandardSearch.aspx
    }

    extractRepresentationTypeParam(params) {
        return this.extractUrlParam(params, "representationtype") 
        || this.extractUrlParam(params, "CTRYID");  // StandardSearch.aspx
    }

    extractPhysicalVenueParam(params) {
        return this.extractUrlParam(params, "physicalvenue") 
        || this.extractUrlParam(params, "VNID");  // StandardSearch.aspx
    }
    
    extractRegionParam(params) {
        return this.extractUrlParam(params, "region") 
        || this.extractUrlParam(params, "REG");  // StandardSearch.aspx
    }

    extractPOSParam(params) {
        return this.extractUrlParam(params, "posid") 
            || this.extractUrlParam(params, "POSID");  // RepresentationDetails.aspx
    }

    extractEventIdsParam(params) {
        return this.extractUrlParam(params, "eventids") 
            || this.extractUrlParam(params, "eventid");  // RepresentationDetails.aspx
    }
    
    extractDateParams(params) {
        // Try to get dates params (IS3 format - YYYY-MM-DD)
        let fromDate = this.extractUrlParam(params, "fromDate");
        let toDate = this.extractUrlParam(params, "toDate");
        
        // Try to get old dates params (StandardSearch.aspx - .NET integer format here)
        if (fromDate == undefined)
            fromDate = this.extractUrlParam(params, "FRMD");
        if (toDate == undefined)
            toDate = this.extractUrlParam(params, "TOD");
        
        // Try to get old dates params (StandardSearch.aspx - String (YYYY-MM-DD) format here)
        if (fromDate == undefined)
            fromDate = this.extractUrlParam(params, "FRMDS");
        if (toDate == undefined)
            toDate = this.extractUrlParam(params, "TODS");

        return { fromDate: fromDate, toDate: toDate };
    }

    createFiltersFromUrlParams(url) {
        const { fromDate, toDate } = this.extractDateParams(url.searchParams);
        const urlParamsKit = [
            { name: "searchtext", value: this.extractSearchTextParam(url.searchParams) },
            { name: "representationType", value: this.extractRepresentationTypeParam(url.searchParams) },
            { name: "physicalVenue", value: this.extractPhysicalVenueParam(url.searchParams) },
            { name: "region", value: this.extractRegionParam(url.searchParams) },
            { name: "fromDate", value: fromDate },
            { name: "toDate", value: toDate },
            { name: "posid", value: this.extractPOSParam(url.searchParams) },
            { name: "eventids", value: this.extractEventIdsParam(url.searchParams) }, // gère le cas RepresentationDetails.aspx?EventID=9616;9617;9618;9619;9620
            { name: "packageids", value: url.searchParams.get("packageids") },
            { name: "promodefid", value: url.searchParams.get("promodefid") }
        ];

        return filter(urlParamsKit, param => { return param.value != null; });
    }
    //#endregion

    getAdvancedSearchControls() {
        let advancedSearchControls = [];
        let activeRepresentationType = this.getRepresentationTypeNameById(this.getFilterValue('representationType'));
        let activePhysicalVenue = this.getPhysicalVenueNameById(this.getFilterValue('physicalVenue'));

        advancedSearchControls.push(
            <div key="searchtext" className="searchbar-item searchbar-item--secondary">  
                <DatePicker
                    key="event-dates-picker"
                    placeholder={tr("Par date")}
                    selectedDates={this.getDateFilters()}
                    onDatesChange={this.handleOnDateCriteriaChange.bind(this)}
                    locale={this.props.lang}
                />
            </div>);

        if(this.state.representationTypes && this.state.representationTypes.length > 1) {
            advancedSearchControls.push(
            <div key="representationTypes" className="searchbar-item searchbar-item--secondary">              
                <Dropdown
                    key="representation-types"
                    placeholder={tr("Par catégorie")}
                    items={this.state.representationTypes}
                    usesSections={true} selectableSections={true}
                    sectionTextField="name" sectionValueField="id" sectionItemsField="children"
                    valueField="id" textField="name"
                    value={activeRepresentationType || ""}
                    onChange={this.handleUpdateFilter.bind(this, "representationType")}
                />
            </div>);
        }

        if(this.state.regions && this.state.regions.length > 1) {
            advancedSearchControls.push(
            <div key="regions" className="searchbar-item searchbar-item--secondary"> 
                <Dropdown
                    key="regions"
                    placeholder={tr("Par région")}
                    items={
                        map(this.state.regions, r => ({
                            key: r,
                            name: r
                        }))
                    }
                    valueField="key" textField="name"
                    value={this.getFilterValue("region") || ""}
                    onChange={this.handleUpdateFilter.bind(this, "region")}
                />
            </div>);
        }

        if (this.state.physicalVenues && 
            (this.state.physicalVenues.length > 1 
                || (this.state.physicalVenues.length === 1 && this.state.physicalVenues[0].physicalVenues.length > 1))
        ) {
            advancedSearchControls.push(  
            <div key="physicalVenues" className="searchbar-item searchbar-item--secondary">               
                <Dropdown
                    key="physical-venues"
                    placeholder={tr("Par salle")}
                    items={this.state.physicalVenues}
                    sectionTextField="cityName" sectionItemsField="physicalVenues"
                    valueField="id" textField="name"
                    value={activePhysicalVenue || ""}
                    onChange={this.handleUpdateFilter.bind(this, "physicalVenue")}
                    usesSections={true}
                    isLarger={true}
                />
            </div>);
        }

        return advancedSearchControls;
    }
    
    buildProductsSections() {
        let allSections = [];
        if (this.state.proposalKit != undefined) {
            if (size(this.state.proposalKit.toCome) > 0)
                allSections.push(
                    <CardsSection
                        key="incomingEvents"
                        title={tr("Événements à venir")}
                        cards={this.state.proposalKit.toCome}
                        urls={this.state.urls}
                        homeUrl={this.props.homeUrl}
                        tr={tr}
                    />
                );
            if (size(this.state.proposalKit.newlyAdded) > 0)
                allSections.push(
                    <CardsSection
                        key="newestEvents"
                        title={tr("Événements nouvellement mis en vente")}
                        cards={this.state.proposalKit.newlyAdded}
                        urls={this.state.urls}
                        homeUrl={this.props.homeUrl}
                        tr={tr}
                    />
                );
            if (size(this.state.proposalKit.mostPopular) > 0)
                allSections.push(
                    <CardsSection
                        key="mostPopularEvents"
                        title={tr("Événements les plus populaires")}
                        cards={this.state.proposalKit.mostPopular}
                        urls={this.state.urls}
                        homeUrl={this.props.homeUrl}
                        tr={tr}
                    />
                );

            /*
               // if (this.state.searchResult.Subscription)
               objList.push(
               {
               title: tr("Forfaits les plus avantageux"),
               key: "packages",
               sectionData: this.props.proposalKit.toCome // change to Subscription later
               });
             */
        }
        return allSections;
    }
    //#endregion

    //#region Render
    render() {
        //#region Proposal Kit
        let cardControls = [];
        const hasActiveFilters = size(this.state.filters) > 0;

        if (hasActiveFilters || tsapp.isShop) {
            cardControls.push(
                <CardsSection
                    key="results"
                    title={this.state.initialShopAllProductsLoading ? tr("Programmation complète") : tr("Résultats")}
                    cards={this.state.searchKit.products}
                    displayAsGrid
                    urls={this.state.urls}
                    homeUrl={this.props.homeUrl}
                    tr={tr}
                />
            );
        } else {
            cardControls = this.buildProductsSections();
        }
        let productsContainer;
        if (this.state.loadingSearchResults || this.state.loadingUrls || this.state.loadingProposalKit) // Searching results
            productsContainer = (<WaitSpinners.PleaseWaitSpinner size="md" integ={this.props.integ} />);
        else if (this.state.searchFailed) // Search has failed
            productsContainer = <NoProductSection message={tr("Une erreur est survenue. Veuillez réessayer.")} />;
        else if (hasActiveFilters && isEmpty(this.state.searchKit.products) && !this.state.loadingSearchResults) // No result from search 
            productsContainer = <NoProductSection message={tr("Nous n'avons trouvé aucun résultat pour votre recherche.")} />;
        else // Display proposal kit or search results
            productsContainer = <div className="overflow-hidden">
                {cardControls}
            </div>;
        //#endregion

        //#region Search
        let searchFilterChips = this.generateFilterChips();
        let advancedSearchInputs = this.getAdvancedSearchControls();
        let searcCriteriaCtrls = concat([
            <div className="searchbar-item search-input searchbar-item--big" key="item--big">
                <Textbox 
                    focus={true}
                    placeholder={tr("Par événement ou artiste")}
                    onChange={this.handleUpdateFilter.bind(this, "searchtext")}
                    value={this.getFilterValue("searchtext") || ""}
                />
            </div>
            ],
            advancedSearchInputs,
            [
                <div className="searchbar-item searchbar-item--small search-btn" key="item--small">
                    <Button key="btnSearch"
                            id="btn-search"
                            icon="search"
                            hasOnlyIconButton={true}
                            onButtonClicked={this.triggerSearchProduct.bind(this)}
                    >
                        <i className="rese-button-icon material-icons mdc-button__icon" aria-hidden="true">search</i>
                    </Button> 
                </div>
            ]
        );

        let moreFiltersButtonText = tr("Recherche avancée");
        if (this.state.showAdvancedSearch) {
            moreFiltersButtonText = tr("Cacher");
        }

        const onMoreFiltersButtonClick = () => {
            this.setState({ showAdvancedSearch: !this.state.showAdvancedSearch });
        };
        //#endregion

        return (
            <div>
                <div className="row-content-with-padding searchbar">                   
                    <div className="searchbar-desktop">
                        {searcCriteriaCtrls}   
                    </div>                                                      
                    <div className={"searchbar-mobile " + (this.state.showAdvancedSearch ? '' : 'hidden')}>
                        {advancedSearchInputs} 
                    </div>
                    <div className="more-filters">
                        <Button onButtonClicked={onMoreFiltersButtonClick} addLetterSpacing={false} hasBackground={false}>
                            <span>{moreFiltersButtonText}</span>
                        </Button>
                    </div>
                    <div className="search-tags">
                        {searchFilterChips}
                    </div>              
                </div>               
                {this.props.children}
                <div className="spacer-row"></div>
                {productsContainer}
                <div className="spacer-row"></div>
            </div>
        );
    }
    //#endregion
}
SearchWidget.propTypes = {
    onChange: PT.func,
    pagging: PT.number,
    proposalKit: PT.object,
    homeUrl: PT.string,
    lang: PT.string,
    integ: PT.string.isRequired,
    sellerId: PT.number,
    loadingSearchResults: PT.bool,
    proposalKitLoadUrl: PT.string
};
SearchWidget.defaultProps = {
    loadingSearchResults: false 
};
